import { gql } from "urql";
export const WebsiteLeadReceivedSubscription = gql `
    subscription WebsiteLeadReceived {
        websiteLeadReceived {
            websiteLeadId
            caregiverId
            patientId
            caregiver {
                userId
                firstName
                lastName
                email
                phoneNumber
            }
            patient {
                patientId
                firstName
                lastName
                dateOfBirth
                postalCode
                postalCodeInfo {
                    city
                    stateId
                    postalCode
                }
            }
            therapyCategory {
                therapyCategoryId
                name
            }
            createdAt
            archivedAt
            movedToPipeline
        }
    }
`;
